<template>
  <div>
    <a-input-group compact>
      <a-select
        :mode="field.mode == 'default' ? null : field.mode"
        size="small"
        :dropdownMatchSelectWidth="false"
        :maskClosable="false"
        v-model:value="modalRef.selectedRows"
        :show-search="!!field.show_search"
        style="width: 66%; min-width: 150px"
        :disabled="field.disabled"
        :placeholder="placeholder"
        :default-value="field.defaultValue"
        :allow-clear="field.allowClear"
        :maxTagCount="field.maxTagCount"
        @change="handleChange"
      >
        <a-select-option
          v-for="option in datasource"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </a-select-option>
      </a-select>
      <a-button
        :disabled="field.disabled"
        size="small"
        style="width: 24%"
        type="primary"
        @click="openModal"
      >
        选择
      </a-button>
    </a-input-group>
    <a-modal
      :title="field.title"
      width="900px"
      :open="modalRef.open"
      :confirmLoading="loading"
      centered
      @ok="handleSubmit"
      @cancel="
        () => {
          modalRef.open = false;
        }
      "
    >
      <search-render
        v-if="searchConfig"
        :form="searchConfig"
        :model="search_modelRef"
        :options="searchConfigOptions"
        :validateInfos="searchValidateInfos"
        @search="search"
      />
      <a-table
        bordered
        size="small"
        :loading="state.loading"
        :scroll="{ y: 400, x: columnState.tableWidth }"
        :row-selection="rowSelection"
        :columns="dynamicColumns"
        row-key="id"
        :data-source="state.dataSource"
        :pagination="{
          current: state.current,
          pageSize: state.pageSize,
          total: state.total,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ['10', '20', '50', '200', '1000', '3000', '10000', '50000', '100000'],
        }"
        @change="handleTableChange"
      >
        <template
          v-for="item in slotList"
          v-slot:[item.slotName]="{ index, text, record }"
          :key="item.slotName"
        >
          <span v-if="item.slotName === 'index'">
            {{ index + 1 + state.pageSize * (state.current - 1) }}
          </span>
          <span v-if="item.type === 'custom'">
            {{ item['field_' + text] }}
          </span>
          <span v-if="item.type === 'custom1'">
            <span v-if="item.content">
              {{ item.content(record) }}
            </span>
          </span>
          <span v-if="item.type === 'datetime'">
            {{ getDateTime(text) }}
          </span>
          <span v-if="item.type === 'date'">
            {{ getDate(text) }}
          </span>
          <span v-if="item.type === 'full_date'">
            {{ getFullDate(text) }}
          </span>
          <span v-if="item.type === 'time'">
            {{ getTime(text) }}
          </span>
          <a-button
            size="small"
            v-if="item.type === 'attributetable'"
            type="link"
            @click="item.cb(text, record)"
          >
            查看属性
          </a-button>
          <a-tag
            :color="item.color ? item.color(record) : 'green'"
            v-if="item.type === 'tag'"
          >
            <span v-if="item.content">
              {{ item.content(record) }}
            </span>
            <span v-else>
              {{ text }}
            </span>
          </a-tag>
          <a-tag
            color="green"
            v-if="text && item.type === 'boolean'"
          >
            {{ item.name1 }}
          </a-tag>
          <a-tag
            color="red"
            v-if="!text && item.type === 'boolean'"
          >
            {{ item.name2 }}
          </a-tag>
          <template v-if="item.type === 'list'">
            <a-tag
              color="#87d068"
              v-for="obj in text"
              :key="obj.id"
              style="margin-bottom: 1px"
            >
              {{ obj.name }}
            </a-tag>
          </template>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, reactive, ref, watch } from 'vue';
import { useFetchData } from '../../../utils/hooks/useFetchData';
import { useForm } from 'ant-design-vue/es/form';
import getFormConfig from 'liyu-pc-base/components/FormRender/RemoteModal/index';
import { useTableDynamicColumns } from '../../../utils/hooks/useTableColumn';
import { getDate, getDateTime, getFullDate, getTime } from '../../../utils/function';
import { useUserStore } from '../../../init-plugin';
import { getApiData } from '../../../api/api-model';

// type Key = ColumnProps['key'];

// interface DataType {
//   id: number;
//   key: Key;
//   name: string;
// }

export default defineComponent({
  name: 'RemoteModal',
  props: {
    field: {
      type: Object,
      required: true,
    },
    modalType: {
      type: String,
      required: true,
      default: () => '',
    },
    value: {
      type: [Array, String, Number],
      required: false,
      default: () => [],
    },
    init_model: {
      type: Object,
      default: () => {},
    },
    field_status: {
      type: Object,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    watch: {
      type: Array,
      default: () => [],
    },
    formModel: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  emits: ['update:value', 'update:label'],
  setup(props, { emit }) {
    const loading = ref(false);
    const { searchConfig, searchConfigOptions, getData, columns, slotList } = getFormConfig(
      props.modalType,
    );
    const search_modelRef = reactive({
      ...searchConfig.model,
      is_active: true,
      ...props.init_model,
    });

    for (const field of searchConfig.fields) {
      if (props.field_status && props.field_status.hasOwnProperty(field.name)) {
        if (props.field_status[field.name] == 0) {
          field.disabled = true;
          field.hidden = false;
        } else if (props.field_status[field.name] == 1) {
          field.disabled = false;
          field.hidden = true;
        } else {
          field.disabled = false;
          field.hidden = false;
        }
      }
    }

    const old_obj: { [key: string]: any } = {};
    onMounted(() => {
      if (props.watch) {
        for (const k of props.watch) {
          if (props.formModel) {
            old_obj[k as string] = props.formModel[k as string];
          }
        }
      }
      if (props.watch && props.formModel) {
        for (const k of props.watch) {
          search_modelRef[k as string] = props.formModel[k as string];
          watch(
            () => props.formModel[k as string],
            () => {
              if (props.watch && props.formModel) {
                for (const k of props.watch) {
                  if (old_obj[k as string] != props.formModel[k as string]) {
                    search_modelRef[k as string] = props.formModel[k as string];
                  }
                }
              }
            },
            { immediate: true },
          );
        }
      }
    });

    const { state: columnState, dynamicColumns } = useTableDynamicColumns(
      columns as TableColumn[],
      {
        checkAll: false,
        needRowIndex: false,
      },
    );
    const get_value_key = () => {
      return props.field.valueKey ? (props.field.valueKey as string) : 'id';
    };
    const get_label_key = () => {
      return props.field.labelKey ? (props.field.labelKey as string) : 'name';
    };
    const datasource = computed(() => {
      return modalRef.datasource.map(item => {
        if (props.field.labelKeyList) {
          const label = [];
          for (const key of props.field.labelKeyList) {
            label.push(item[key as string]);
          }
          return {
            value: item[get_value_key()],
            label: label.join(props.field.labelSpace),
          };
        } else {
          return {
            value: item[get_value_key()],
            label: item[get_label_key()],
          };
        }
      });
    });
    const modalRef = reactive({
      open: false,
      selectedRows: new Array<number>(),
      selectedRowsKey: new Array<number>(),
      selectedRowsTotal: new Array<any>(),
      datasource: new Array<any>(),
      datasource_keys: new Array<any>(),
    });

    const rowSelection = {
      type:
        props.field.mode == 'default'
          ? 'radio'
          : props.field.mode == 'multiple'
          ? 'checkbox'
          : 'checkbox',
      columnWidth: '30px',
      selectedRowKeys: modalRef.selectedRowsKey,
      onChange: (selectedRowKeys: any, selectedRows: any) => {
        // modalRef.selectedRowsKey.length = 0;
        const remove_key: Array<number> = modalRef.selectedRowsKey.filter(
          item => selectedRowKeys.indexOf(Number(item)) == -1,
        );
        modalRef.selectedRowsTotal = modalRef.selectedRowsTotal.filter(
          item => remove_key.indexOf(item.id) == -1,
        );
        selectedRows.forEach((item: any) => {
          if (modalRef.selectedRowsKey.indexOf(item.id) == -1) {
            modalRef.selectedRowsTotal.push(item);
          }
        });

        modalRef.selectedRowsKey.length = 0;
        selectedRows.forEach((item: any) => {
          modalRef.selectedRowsKey.push(item.id);

          // modalRef.datasource.push(item);
        });
      },
      onSelect: (record: any, selected: any) => {
        if (props.field.mode == 'multiple') {
          if (selected) {
            if (
              modalRef.datasource_keys.indexOf(
                record[props.field.valueKey ? (props.field.valueKey as string) : 'id'] == -1,
              )
            ) {
              modalRef.datasource_keys.push(
                record[props.field.valueKey ? (props.field.valueKey as string) : 'id'],
              );
              modalRef.datasource.push(record);
            }
          } else {
            modalRef.datasource_keys = modalRef.datasource_keys.filter(item => item !== record.id);
            modalRef.datasource = modalRef.datasource.filter(item => item.id !== record.id);
          }
        } else {
          modalRef.datasource_keys.length = 0;
          modalRef.datasource.length = 0;
          if (selected) {
            if (
              modalRef.datasource_keys.indexOf(
                record[props.field.valueKey ? (props.field.valueKey as string) : 'id'] == -1,
              )
            ) {
              modalRef.datasource_keys.push(
                record[props.field.valueKey ? (props.field.valueKey as string) : 'id'],
              );
              modalRef.datasource.push(record);
            }
          }
        }
      },
    };

    const {
      reload,
      setPageInfo,
      context: state,
    } = useFetchData(getData, {
      current: 1,
      pageSize: 20,
      tableSize: 'middle', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        ...search_modelRef,
      },
    });
    watch(
      () => state.dataSource,
      () => {
        const total_ids: Array<number> = modalRef.selectedRowsTotal.map(item => item.id);
        state.dataSource.map((item: any) => {
          if (total_ids.indexOf(item.id) > -1) {
            modalRef.selectedRowsKey.push(item.id);
          }
        });
      },
    );
    const init = () => {
      modalRef.datasource.length = 0;
      modalRef.selectedRows.length = 0;
      modalRef.selectedRowsKey.length = 0;
      modalRef.selectedRowsTotal.length = 0;
      modalRef.datasource_keys.length = 0;
      let list: any[] = [];
      if (props.value instanceof Array) {
        if (props.value.length > 0) {
          list = props.value as Array<number>;
        }
      } else if (typeof props.value == 'string') {
        (props.value as string).split(',').map((item: any) => {
          list.push(Number(item));
        });
      } else {
        if (props.value) {
          list.push(props.value);
        }
      }
      if (list.length > 0) {
        const tmp_ids: any[] = [];
        const tmp_item_ids: any[] = [];
        modalRef.datasource.map(item => tmp_item_ids.push(item.id));
        list.map(item => {
          if (modalRef.selectedRows.indexOf(Number(item)) == -1) {
            modalRef.selectedRows.push(Number(item));
            modalRef.selectedRowsKey.push(Number(item));
          }
          if (tmp_item_ids.indexOf(item) == -1) {
            tmp_ids.push(item);
          }
        });
        if (tmp_ids.length > 0) {
          getApiData(
            { current: 1, ...search_modelRef, pageSize: 2000, ids: tmp_ids.join(',') },
            getData,
          ).then(function (res: ReponseData<any>) {
            res.data.forEach(item => {
              if (list.indexOf(item.id) >= 0) {
                modalRef.datasource.push(item);
                modalRef.selectedRowsTotal.push(item);
                modalRef.datasource_keys.push(item.id);
              }
            });
            if (props.field.mode == 'default') {
              if (modalRef.selectedRows.length == 1) {
                const selectItems: any = datasource.value
                  .filter((item: any) => modalRef.selectedRows.includes(item.value))
                  .map((item: any) => item.label);
                emit('update:label', selectItems.length > 0 ? selectItems[0] : '');
              } else {
                emit('update:label', '');
              }
            } else {
              emit(
                'update:label',
                datasource.value
                  .filter((item: any) => modalRef.selectedRows.includes(item.value))
                  .map((item: any) => item.label),
              );
            }
          });
        }
      } else {
        modalRef.selectedRows.length = 0;
        modalRef.selectedRowsKey.length = 0;
        modalRef.selectedRowsTotal.length = 0;
      }
    };
    init();

    watch(
      () => props.value,
      () => {
        init();
      },
    );

    const handleTableChange = (
      { current, pageSize }: Pagination,
      filters: TableFilters,
      sorter: TableColumnSortOrder,
    ) => {
      console.log(sorter);
      setPageInfo({
        current,
        pageSize,
        ...filters,
        ...search_modelRef,
      });

      reload();
    };

    const { validateInfos: searchValidateInfos } = useForm(search_modelRef, searchConfig.rules);

    const search = () => {
      setPageInfo({
        current: 1,
        ...search_modelRef,
      });
      reload();
    };

    const openModal = () => {
      modalRef.open = true;
      const remove_ids: Array<number> = modalRef.datasource
        .filter(item => modalRef.selectedRows.indexOf(item.id) == -1)
        .map(item => item.id);
      remove_ids.forEach(item => {
        if (modalRef.selectedRowsKey.indexOf(item) != -1) {
          modalRef.selectedRowsKey.splice(modalRef.selectedRowsKey.indexOf(item), 1);
        }
      });

      const remove_total: Array<any> = modalRef.selectedRowsTotal.filter(
        item => modalRef.selectedRows.indexOf(item.id) == -1,
      );
      remove_total.forEach(item => {
        if (modalRef.selectedRowsTotal.indexOf(item) != -1) {
          modalRef.selectedRowsTotal.splice(modalRef.selectedRowsTotal.indexOf(item), 1);
        }
      });
    };

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      modalRef.open = false;
      if (modalRef.selectedRows == undefined) {
        modalRef.selectedRows = new Array<number>();
      }
      modalRef.selectedRows.length = 0;
      modalRef.datasource.map(item =>
        modalRef.selectedRows.push(
          item[props.field.valueKey ? (props.field.valueKey as string) : 'id'],
        ),
      );
      // modalRef.datasource.length = 0;
      // modalRef.selectedRowsTotal.map(item => modalRef.datasource.push(item));
      if (props.field.mode == 'default') {
        if (modalRef.selectedRows.length == 1) {
          emit('update:value', modalRef.selectedRows[0]);
          const selectItems: any = datasource.value
            .filter((item: any) => {
              return modalRef.selectedRows == item.value;
            })
            .map((item: any) => item.label);
          emit('update:label', selectItems.length > 0 ? selectItems[0] : '');
        } else {
          emit('update:value', null);
          emit('update:label', '');
        }
      } else {
        emit('update:value', modalRef.selectedRows);
        emit(
          'update:label',
          datasource.value
            .filter((item: any) => modalRef.selectedRows.includes(item.value))
            .map((item: any) => item.label),
        );
      }
    };
    const handleChange = (value: any) => {
      if (props.field.mode == 'default') {
        if (value == undefined) {
          modalRef.selectedRows = new Array<number>();
        } else {
          modalRef.selectedRows = [value];
        }
      } else {
        modalRef.selectedRows = value;
      }
      emit('update:value', value);
    };
    return {
      props,
      modalRef,
      datasource,
      state,
      loading,
      getDateTime,
      getDate,
      getFullDate,
      getTime,
      search,
      openModal,
      handleSubmit,
      handleChange,
      handleTableChange,
      rowSelection,
      searchValidateInfos,
      search_modelRef,
      searchConfig,
      searchConfigOptions,
      columnState,
      dynamicColumns,
      slotList,
    };
  },

  data() {
    return {
      model: this.value,
    };
  },
});
</script>
